<!-- Print Button -->
<button class="noPrint btn-primary" 
        style="width: 10%; height: 30px; margin-left: 80%;" 
        mat-raised-button 
        color="primary"
        printSectionId="print-section" 
        ngxPrint 
        [useExistingCss]="true">
  print
</button>

<!-- Print Section -->
<div id="print-section">
  <ng-container *ngFor="let bookpymtrcptdata of data2; let i = index">
    
    <!-- Receipt Wrapper with proper spacing -->
    <div [ngClass]="{ 'receipt-spacing': i < data2.length - 1 }">
      <div class="mt-55">
        
        <!-- Page Break: Insert after every 2 receipts -->
        <div *ngIf="i > 0 && i % 2 === 0" class="page-break"></div>
        
        <!-- Receipt Container -->
        <div class="container" style="border: 2px solid black">
          
          <!-- Header Row -->
          <div class="row">
            
            <!-- Logo Column -->
            <div class="col-3">
              <img
                style="margin-top: 30%"
                width="80%"
                src="../../../assets/img/brand/book.png"
                alt="Logo"
              />
            </div>
            
            <!-- Organization Details Column -->
            <div class="col-7" style="padding-top: 30px; text-align: center; padding-bottom: 10px">
              <span style="font-size: 30px; font-weight: bold">हिंदुस्थान प्रकाशन संस्था</span>
              <span style="font-size: 16px; margin-left: 05px">(Reg.No.-BOM-3/1961(GBBSD)</span>
              <hr />
              
              <!-- Office Details Row -->
              <div class="row" style="text-align: left">
                
                <!-- Administrative Office -->
                <div class="col-6" style="padding-top: 10px">
                  <span style="font-size: 15px">
                    <span style="font-weight: bold; font-size: 18px">प्रशासकीय कार्यालय :<br></span>
                    116, 117, 118, 119, <br> पहिला मजला, शिल्पीन सेंटर, ग. द. आंबेकर मार्ग, वडाळा, मुंबई - 400031<br />
                  </span>
                  <span style="font-size: 17px">
                    <span style="font-weight: bold; font-size: 16px">दूरध्वनी:</span> 9967570531
                  </span>
                </div>
                
                <!-- Main Office -->
                <div class="col-6" style="border-style: solid; border-width: 0px 0px 0px 2px; padding-top: 10px">
                  <span style="font-size: 15px">
                    <span style="font-weight: bold; font-size: 19px">मुख्य कार्यालय :<br></span>
                    5/12, कामत औद्योगिक वसाहत, <br> 396 स्वा. वीर सावरकर मार्ग, <br> प्रभादेवी, मुंबई 400025.<br />
                  </span>
                  <span style="font-size: 17px">
                    <span style="font-weight: bold; font-size: 17px">दूरध्वनी : </span> 24221440
                  </span>
                </div>
              </div>
            </div>
            
            <!-- Receipt Title Column -->
            <div class="col-2" style="border-style: solid; border-width: 0px 0px 0px 2px; padding-top: 80px; text-align: center">
              <span style="font-size: 24px">पुस्तक जमा <br> पावती</span>
            </div>
          </div>
          
          <!-- Seller & Receipt Details Row -->
          <div class="row" style="border-style: solid; border-width: 2px 0px 0px 0px; text-align: center">
            
            <!-- Book Seller Information -->
           <!-- Book Seller Information -->
<div class="col-6" style="padding-top: 20px; text-align: left">

  <div style="margin-bottom: 5px;">
    <span style="font-weight: bold; font-size: 17px">
      Book Seller Name:&nbsp;
    </span>
    <span style="font-size: 16px">
      {{ bookpymtrcptdata["book_seller_name"] }}
    </span>
  </div>

  <div style="margin-bottom: 5px;">
    <span style="font-weight: bold; font-size: 16px">
      Address :&nbsp;
    </span>
    <span style="font-size: 16px; display: inline;">
      {{ bookpymtrcptdata.receiver_address }}
    </span>
  </div>

  <div style="margin-top: 8px;">
    <span style="font-weight: bold; font-size: 17px">
      Mobile No :&nbsp;
    </span>
    <span style="font-size: 16px">
      {{ bookpymtrcptdata["mobile"] }}
    </span>
  </div>

</div>
            
            <!-- Payment Details -->
            <div class="col-6" style="border-style: solid; border-width: 0px 0px 0px 2px">
              
              <!-- Receipt Number & Date -->
              <div class="row" style="border-style: solid; border-width: 0px 0px 2px 0px; text-align: center; padding-top: 20px; padding-bottom: 10px">
                <div class="col-6" style="text-align: left">
                  <span style="font-weight: bold; font-size: 17px">पावती क्रं.: </span>
                  <span>{{ bookpymtrcptdata["receipt_no"] }}</span>
                </div>
                <div class="col-6" style="text-align: left">
                  <span style="font-weight: bold; font-size: 17px">दिनांक:&nbsp;</span>
                  <span style="font-size: 16px">{{ bookpymtrcptdata["voucher_date"] | date: "dd-MM-yyy" }}</span>
                </div>
              </div>
              
              <!-- Amount Received -->
              <div class="row" style="padding-top: 10px">
                <div class="col-12" style="text-align: left">
                  <span style="font-weight: bold; font-size: 17px">यांचेकडुन रुपये&nbsp;</span>
                  <span style="font-size: 16px">{{ bookpymtrcptdata["select_entry_amt"] }} /-</span>
                </div>
              </div>
              
              <div class="row">
                <div class="col-12" style="text-align: right">
                  <span style="font-weight: bold; font-size: 1px">मात्र साभार पोहोचले.</span>
                </div>
              </div>
              
              <!-- Cheque Details -->
              <div class="row" style="padding-top: 05px">
                <div class="col-6" style="text-align: left">
                  <span style="font-weight: bold; font-size: 16px">धनादेश क्रं.:&nbsp;</span>
                  <span style="font-size: 15px">{{ bookpymtrcptdata["cheque_no"] }}</span>
                </div>
                <div class="col-6" style="text-align: left">
                  <span style="font-weight: bold; font-size: 16px">दिनांक:&nbsp;</span>
                  <span *ngIf="bookpymtrcptdata['cheque_date'] === '0000-00-00'">
                    {{ bookpymtrcptdata["cheque_date"] }}
                  </span>
                  <span *ngIf="bookpymtrcptdata['cheque_date'] !== '0000-00-00'">
                    {{ bookpymtrcptdata["cheque_date"] | date: "yyyy-MM-dd" }}
                  </span>
                </div>
              </div>
              
              <!-- Bank -->
              <div class="row">
                <div class="col-12" style="text-align: left; padding-top: 05px">
                  <span style="font-weight: bold; font-size: 16px">बँक:&nbsp;</span>
                  <span style="font-size: 15px"> </span>
                </div>
              </div>
              
              <!-- Deposited Amount -->
              <div class="row">
                <div class="col-12" style="text-align: left; padding-top: 05px; padding-bottom: 05px">
                  <span style="font-weight: bold; font-size: 16px">जमा रक्कम रु.&nbsp;</span>
                  <span style="font-size: 15px">{{ bookpymtrcptdata["select_entry_amt"] }} /-</span>
                </div>
              </div>
              
              <!-- Amount in Words -->
              <div class="row">
                <div class="col-12" style="text-align: left; padding-top: 05px; padding-bottom: 05px">
                  <span style="font-weight: bold; font-size: 16px">अक्षरी रक्कम.&nbsp;</span>
                  <span style="font-size: 15px">{{ numbertotext(bookpymtrcptdata.select_entry_amt) }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Bill / Order No Row -->
          <div class="row" style="border-top: 2px solid black">
            <div class="col-12" style="text-align: left; padding: 8px;">
              <b>{{ getLabel(bookpymtrcptdata) }}</b>
              {{ getValue(bookpymtrcptdata) }}
            </div>
          </div>
          
          <!-- Footer Row -->
          <div class="row" style="margin-top: 80px; padding-bottom: 10px">
            <div class="col-6">
              <span style="font-weight: bold; font-size: 16px">(धनादेश वटल्यावरच पावती अधिकृत होईल)</span>
            </div>
            <div class="col-6" style="text-align: right; font-weight: bold; font-size: 16px">
              <span>व्यवस्थापक / लेखापाल</span>
            </div>
          </div>
          
        </div>
        <!-- End Receipt Container -->
        
      </div>
    </div>
    <!-- End Receipt Wrapper -->
    
  </ng-container>
</div>